<template>
  <div class="popup-container">
    <div class="custom-label">弹窗图片</div>
    <div class="custom-upload">
      <div>
        <image-selector v-model="popupImage" />
        <p v-if="!popupImage" class="tip-error">请上传弹窗图片</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "customImage",
  data() {
    return {
      popupImage: ''
    }
  },
  watch: {
    popupImage: {
      deep: true,
      immediate: false,
      handler(newVal) {
        this.$$FormData.popup_image = newVal.src || ''
      }
    },
  },
  mounted() {
    this.popupImage = { src: this.$$FormData.popup_image }
  }
}
</script>

<style lang="scss" scoped>
.popup-container {
  display: flex;
  align-items: center;
  .custom-label {
    padding: 24px 16px;
    margin: 0;
    font-size: 14px;
    color: #969799;
    line-height: 18px;
    white-space: nowrap;
  }
}
.custom-upload {
  display: flex;
  align-items: flex-end;
  margin-top: 12px;
  line-height: normal;
  .upload-box,
  .custom-img {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    overflow: hidden;
    color: #155bd4;
    font-size: 20px;
    border: 1px solid #e5e5e5;
    background-color: #f2f4f6;
    cursor: pointer;
    .label-box {
      font-size: 12px;
      margin: 0;
      margin-top: 4px;
    }
  }
  .tip-error {
    margin-top: 5px;
    font-size: 12px;
    color: #d40000;
  }
  .tip-upload {
    color: #969799;
    margin-left: 10px;
    font-size: 12px;
  }
  .custom-img {
    position: relative;
    cursor: auto;
    .img-upload {
      width: 100%;
      height: 100%;
    }
    .change-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      color: #ffffff;
      background-color: rgba(0,0,0,.5);
      cursor: pointer;
    }
  }
}
</style>